import { Theme } from "main/types/theme";
import { hex2rgba, shadeColorLog } from "main/styles/variables/colorStyle";

const defaultTheme = {
  color: {
    primary: "#AF9267",
    secondary: "#6AA8B5",
  },
};

export function generateThemeStyles(theme: Theme.Theme) {
  const styles = {};
  const primaryColor = theme.color.primary || defaultTheme.color.primary;
  const secondaryColor = theme.color.secondary || defaultTheme.color.secondary;

  styles["--color-primary"] = primaryColor;
  styles["--color-primary--light"] = shadeColorLog(hex2rgba(primaryColor), 0.1);
  styles["--color-primary--dark"] = shadeColorLog(hex2rgba(primaryColor), -0.2);

  styles["--color-secondary"] = secondaryColor;
  styles["--color-secondary--light"] = shadeColorLog(
    hex2rgba(secondaryColor),
    0.1,
  );
  styles["--color-secondary--dark"] = shadeColorLog(
    hex2rgba(secondaryColor),
    -0.2,
  );

  return styles;
}

export function generateHotelThemeStyles(
  primaryColor?: string,
  secondaryColor?: string,
) {
  const theme: Theme.Theme = {
    color: { primary: primaryColor, secondary: secondaryColor },
  };
  return generateThemeStyles(theme);
}
